module.exports = __webpack_public_path__ + "static/media/social-sciences-law.cfbfafb3.webp";